import React, { useState, useEffect } from 'react'
import { Steps,} from 'antd'
import { useKPSQspjdListQuery } from '../../store/DianShangYeWuApi';
function InvoiceNodeAdd(props) {
    const [items, setItems] = useState([]); 
    const {data, isSuccess} = useKPSQspjdListQuery({kpsq_spjd_qy_id:props.qy_id,kpsq_spjd_user_id:props.user_id},{skip:!props.user_id});
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const sortedData = [...data.Result].sort((a, b) => {
                        return Number(a.kpsq_spjd_xuhao) - Number(b.kpsq_spjd_xuhao);
                })
                const arr = sortedData.map((item) => ({
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>{item.kpsq_spjd_name}</span>       ,
                    content:<span style={{fontSize:"12px"}}>{item.kpsq_spjd_yh_name}</span>,
                }))
                setItems([{
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>创建</span>,
                    content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
                },
                {
                    title:<span style={{fontSize:"14px",fontWeight:"bold"}}>提交</span>,
                    content:<span style={{fontSize:"12px"}}>{props.yh_name}</span>,
                },...arr]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.yh_name])    
    return (
        <Steps items={items} current={0} size="small" titlePlacement="vertical"/>
    )
}

export default InvoiceNodeAdd